"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMessageTimestamp = exports.MessageTimestampController = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const TimestampContext = (0, react_1.createContext)({
    timestampEnabled: false,
    toggleTimestamp: () => null
});
const MessageTimestampController = ({ children }) => {
    const [timestampEnabled, setShowTimestamp] = (0, react_1.useState)(false);
    const toggleTimestamp = (0, react_1.useCallback)(() => {
        setShowTimestamp((prev) => !prev);
    }, []);
    return ((0, jsx_runtime_1.jsx)(TimestampContext.Provider, { value: { timestampEnabled, toggleTimestamp }, children: children }));
};
exports.MessageTimestampController = MessageTimestampController;
const useMessageTimestamp = () => (0, react_1.useContext)(TimestampContext);
exports.useMessageTimestamp = useMessageTimestamp;
